
import { isStringWithValue } from '@/common/utils';
import { ObjectsType } from '@/store/application/data.assets';
import { featuresModule } from '@/store/features';
import { NHint } from '@/uikit/hint';
import { Options, Prop, Vue } from 'vue-property-decorator';

@Options({
  components: { NHint },
  methods: { isStringWithValue }
})
export default class Features extends Vue {
  @Prop({ default: false, type: Boolean })
  readonly columns!: boolean;

  @Prop({ required: true, type: Object })
  readonly features!: Record<string, any>;

  @Prop({ default: false, type: Boolean })
  readonly header!: boolean;

  @Prop({ required: true, type: String })
  readonly objects!: ObjectsType;

  @Prop({ type: Boolean })
  readonly clusters: boolean = false;

  @Prop({ default: 'x-small', type: String })
  readonly size!: '2x-small' | 'small' | 'x-small';

  get classes() {
    return {
      'label-2xs': this.size === '2x-small',
      'label-s': this.size === 'small',
      'label-xs': this.size === 'x-small',
      features_columns: this.columns,
      features: true
    };
  }

  get featureProperties() {
    return featuresModule.getFeatureProperties(this.features as any, this.objects, this.clusters);
  }
}
